var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { name: "delete-photo-modal", width: 0 },
      on: { "before-open": _vm.beforeOpen, closed: _vm.closed }
    },
    [
      _c(
        "div",
        { staticClass: "modal modal__sphir_Online_Access_Agreement show" },
        [
          _c("section", [
            _c("a", { staticClass: "modal__close" }, [
              _c("i", { staticClass: "icon-close", on: { click: _vm.hide } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text__center margin-b__20" }, [
              _c("b", [
                _vm._v(
                  "Are you sure you want to delete " +
                    _vm._s(_vm.count) +
                    " selected photo" +
                    _vm._s(_vm.count > 1 ? "s" : "") +
                    "?"
                )
              ])
            ]),
            _vm._v(" "),
            !_vm.loading
              ? _c("div", { staticClass: "text__center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn__reset margin-r__10",
                      on: { click: _vm.hide }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("BUTTON.NO")) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn__m btn__round",
                      on: { click: _vm.deletePhotos }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("BUTTON.YES")) +
                          "\n                "
                      )
                    ]
                  )
                ])
              : _vm.errorMessage
              ? _c("div", { staticClass: "text__center" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.errorMessage) +
                      "\n            "
                  )
                ])
              : _c("div", { staticClass: "text__center" }, [
                  _vm._v(
                    "\n                Processing delete " +
                      _vm._s(_vm.count) +
                      " photos" +
                      _vm._s(_vm.count > 1 ? "s" : "") +
                      "\n                "
                  ),
                  _c("i", { staticClass: "spinner-border" })
                ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }